import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { LegislationEmployeeCostSectionRef } from "../../../../models/legislation-employee-cost-section/legislation-employee-cost-section-ref";
import { ProformaEmployeeCostReportSectionRef } from "../../../../models/proforma-employee-cost-report/proforma-employee-cost-report-section-ref";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";

interface Props {
  sectionName: string;
  calculatedAmount?: number;
  contributions?: ProformaEmployeeCostReportSectionRef[];
  contributesTo?: LegislationEmployeeCostSectionRef[];
  bold?: boolean;
  dividedBy?: number;
  multipliedBy?: number;
}

const ContributingSections = ({
  sectionName,
  calculatedAmount,
  contributions,
  contributesTo,
  bold,
  dividedBy,
  multipliedBy,
}: Props) => {
  const theme = useTheme();

  return (
    <>
      <SimplePopover
        buttonType="text"
        buttonContent={
          <Tooltip title="">
            <Typography
              style={{
                fontWeight: bold ? "bold" : "normal",
              }}
            >
              {calculatedAmount?.toLocaleCustom() ?? sectionName}
            </Typography>
          </Tooltip>
        }
        customButtonStyle={{
          textTransform: "none",
          textAlign: "left",
          padding: 0,
          color: calculatedAmount ? theme.palette.secondary.light : theme.palette.text.primary,
        }}
      >
        <Grid
          style={{
            padding: "15px",
          }}
        >
          {contributions ? `Contributing sections to ${sectionName} :` : `${sectionName} contributes to :`}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Section</TableCell>
                {contributions && <TableCell>Amount</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {contributions?.map((conSec, idx) => (
                <TableRow key={idx}>
                  <TableCell>{conSec.type?.name}</TableCell>
                  <TableCell align="right">{`${
                    conSec.type?.isSubstracted ? "-" : ""
                  } ${conSec.amount.toLocaleCustom()}`}</TableCell>
                </TableRow>
              ))}
              {contributesTo?.map((conSec, idx) => (
                <TableRow key={idx}>
                  <TableCell>{conSec.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <br />
          {!!multipliedBy && multipliedBy > 0 && (
            <Typography>
              <b>Multiplied by : </b> {multipliedBy}{" "}
            </Typography>
          )}
          {!!dividedBy && dividedBy > 0 && (
            <Typography>
              <b> Divided by : </b> {dividedBy}{" "}
            </Typography>
          )}
        </Grid>
      </SimplePopover>
    </>
  );
};
export default ContributingSections;
